export default function CaseStudy() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Реальный кейс: как <strong>тренинг по продажам</strong> меняет показатели
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Международная логистическая компания. Команда из 12 менеджеров по продажам. Результат после комплексной программы.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-gray-50 rounded-2xl p-8 md:p-12">
            <div className="flex items-center gap-4 mb-8">
              <div className="w-16 h-16 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-ship-line text-3xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900">Международная логистическая компания</h3>
                <p className="text-gray-500 text-sm">B2B, 12 менеджеров, полный цикл сопровождения</p>
              </div>
            </div>

            <div className="grid sm:grid-cols-2 gap-6 mb-8">
              <div className="bg-white rounded-xl p-6 text-center">
                <div className="text-3xl md:text-4xl font-extrabold text-teal-600 mb-2">18–23%</div>
                <p className="text-sm text-gray-600">рост конверсии из лида в сделку месяц к месяцу</p>
              </div>
              <div className="bg-white rounded-xl p-6 text-center">
                <div className="text-3xl md:text-4xl font-extrabold text-teal-600 mb-2">+20%</div>
                <p className="text-sm text-gray-600">в среднем за период сопровождения</p>
              </div>
            </div>

            <div className="bg-teal-50 rounded-xl p-6">
              <h4 className="font-bold text-gray-900 mb-3">Что было сделано:</h4>
              <div className="space-y-2 text-sm text-gray-700">
                <div className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>Проведён аудит 120+ звонков и 80+ коммерческих предложений</span>
                </div>
                <div className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>Разработана система квалификации лидов и скрипты для каждого этапа воронки</span>
                </div>
                <div className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>Проведён 2-дневный интенсив и 3 месяца посттренингового сопровождения</span>
                </div>
                <div className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>Создана книга продаж и внедрена система контроля качества</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-10">
          <button
            onClick={() => scrollTo('contact')}
            className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Хочу такой же результат
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}